/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, bool } from 'prop-types';

const ProductPartNumber = ({ selectedSku, classes, isMobile }) => (<p className={classes}>{isMobile && 'Product Number: '} {selectedSku.id}</p>);

ProductPartNumber.propTypes = {
    selectedSku: object.isRequired,
    classes: object.isRequired,
    isMobile: bool,
};

ProductPartNumber.defaultProps = {
    isMobile: false,
};

export default ProductPartNumber;
